<mat-dialog-content>
  <div class="row mb-2">
    <div class="col-3">
      <label>Data Inicial</label>
    </div>
    <div class="col-3">
      <span>{{ period.startDate | date: "dd/MM/yyyy":"+0000" }}</span>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-3">
      <label>Data Final</label>
    </div>
    <div class="col-3">
      <span>{{ period.endDate | date: "dd/MM/yyyy":"+0000" }}</span>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-3">
      <label>Conta</label>
    </div>
    <div class="col-3">
      <span>{{ bankAccount }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <table class="table table-striped">
      <thead class="thead-dark">
        <th scope="col">Data</th>
        <th scope="col">Histórico</th>
        <th scope="col">Código</th>
        <th scope="col">Valor</th>
        <th scope="col">D/C</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of entries">
          <td>{{ item.entryDate | date: "dd/MM/yyyy":"+0000" }}</td>
          <td>{{ item.historyDescription }}</td>
          <td>{{ item.historyCode }}</td>
          <td>{{ item.amount | currency: "R$":"symbol":"1.2-2" }}</td>
          <td>{{ entryTypesDescription[item.entryType] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Fechar</button>
  </mat-dialog-actions>
</mat-dialog-content>
